export default __webpack_public_path__ + "static/media/Contact.26ce3af5.png";